import { Feed, Thread, UnseenThreadEdgesForFeed } from '../../state/types';

interface NormalizeUnseenThreadEdgesOptions {
  readonly feedId: Feed['id'];
  readonly threadIds: Thread['id'][];
  readonly hasMore: boolean;
}

type NormalizeUnseenThreadEdges = (options: NormalizeUnseenThreadEdgesOptions) => UnseenThreadEdgesForFeed;

export const normalizeUnseenThreadEdges: NormalizeUnseenThreadEdges = ({ feedId, threadIds, hasMore }) => {
  const edges = threadIds.map((id) => ({ nodeId: id }));

  return {
    id: feedId,
    threadEdges: edges,
    hasOlderThreads: hasMore,
  };
};
